import React from "react";
import { useNavigate } from "react-router-dom";

function Button({ text, type, arrow, navigateTo }) {
  const navigate = useNavigate();

  return (
    <div>
      {/* //lg:w-[190px] w-[158px] */}
      <button
        onClick={() => navigate(navigateTo)}
        className={` h-[40px] px-5 md:px-[44px] lg:mt-3 rounded-[100px] border border-primary-normal text-center
font-montserrat lg:text-sm text-xs font-semibold shadow-custom transition uppercase flex justify-center items-center gap-2 hover:scale-105 text-nowrap ${
          type === "outline"
            ? " hover:bg-primary-normal hover:text-white"
            : "bg-primary-normal text-white hover:bg-white hover:text-primary-normal "
        }`}
      >
        {text}
        {arrow && (
          <svg
            width="16"
            height="12"
            viewBox="0 0 16 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className=""
              d="M10.1726 11.6538L9.11858 10.5693L12.9378 6.75H0.826324V5.25H12.9378L9.11858 1.43075L10.1726 0.346252L15.8263 6L10.1726 11.6538Z"
              fill="currentColor"
            />
          </svg>
        )}
      </button>
    </div>
  );
}

export default Button;
